@if(true){
      <div class="container-fluid">
        @if (PreFollowUPID == 0) {
            <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
              Update Diary
              <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
              </button>
            </div>
        } @else if( CloseDiaryHeader == 1) {
             <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
              {{ CloseCaption }}
              <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
              </button>
            </div>
        } @else {
              <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
              {{ CaptionAlreadyDone }}
              <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
              </button>
            </div>
        }
<!-- <div class="col-sm-12 mt-3"> -->

  <!-- ===== Titlebar (Default) ===== -->
  <!-- <div class="titlebar d-flex align-items-center justify-content-between" *ngIf="this.PreFollowUPID == 0">
    <div></div>
    <div class="titlebar-text">
      <i class="fa fa-briefcase text-primary"></i>
      <span class="ml-2 page-title">Update Diary</span>
    </div>

    <button class="btn btn-primary back-btn" title="Go Back" (click)="goBack()">
      <i class="fa fa-arrow-left"></i> Back
    </button>
  </div> -->

  <!-- ===== Caption Already Done ===== -->
  <!-- <div class="col-sm-12 lefticonD paddingless tableHeading" 
       style="border-bottom: 1px solid #ccc;" 
       *ngIf="this.PreFollowUPID != 0 && this.CloseDiaryHeader != 1">
    <span class="text-danger">{{ this.CaptionAlreadyDone }}</span>
  </div> -->

  <!-- ===== Titlebar (Close Diary Mode) ===== -->
  <!-- <div class="titlebar d-flex align-items-center justify-content-between" *ngIf="this.CloseDiaryHeader == 1">
    <div></div>
    <div class="titlebar-text">
      <i class="fa fa-briefcase text-primary"></i>
      <span class="ml-2 page-title">{{ CloseCaption }}</span>
    </div>
    <button class="btn btn-primary back-btn" title="Go Back" (click)="goBack()">
      <i class="fa fa-arrow-left"></i> Back
    </button>
  </div> -->

  <!-- ===== FORM START ===== -->
  <form  [formGroup]="FormUpdateDiary" (ngSubmit)="onHeaderSubmit(FormUpdateDiary.value)">

    <!-- ===== My Diary (Header) ===== -->
     @if (CloseDiaryHeader != 1) {
         <div class="page-sub-heading my-3">
            My Diary
         </div>
         <!-- <div class="col-12 fw-bold mt-4">My Diary</div> -->
     }

    <!-- ============================== -->
    <!--     SECTION: Diary Against     -->
    <!-- ============================== -->
     @if (this.CloseDiaryHeader != 1) {
         <div class="card">
            <div class="card-body">
                <div class="row mt-3" >
            
                  <!-- Diary Against -->
                  <div class="col-12 col-md-4">
                    <label class="form-label">Diary Against <span class="text-danger">*</span></label>
                    <ng-select
                      [items]="[{ value:2, label:'Case' }, { value:1, label:'Decision' }, { value:0, label:'Notice' }]"
                      bindLabel="label"
                      bindValue="value"
                      formControlName="ContextType"
                      (change)="onChangeContextType($event)"
                      [clearable]="false"
                      placeholder="Select Diary Against">
                    </ng-select>
                    @if (f.ContextType.touched && f.ContextType.invalid) {
                        @if (f.ContextType.errors?.['required']) {
                            <div class="text-danger">
                                <small>Diary Against is required.</small>
                            </div>
                        }
                    }
                  </div>
            
                  <!-- Case/Notice Dropdown -->
                  <div class="col-12 col-md-4">
                    <label class="form-label">Case / Notice <span class="text-danger">*</span></label>
                    <ng-select 
                        [items]="CaseNoticeList" 
                        formControlName="drpCaseNotice"
                        bindLabel="refno"
                        bindValue="ID"
                        [(ngModel)]="SelectedCaseNotice">
                      <ng-template ng-option-tmp let-item="item">
                        {{item.refno}} ({{item.type}}) ({{item.NoticeDt|date:'dd-MMM-yyyy'}})
                      </ng-template>
                    </ng-select>
                    @if (f.drpCaseNotice.touched && f.drpCaseNotice.invalid) {
                        @if (f.drpCaseNotice.errors?.['required']) {
                            <div class="text-danger">
                                <small>Case / Notice is required.</small>
                            </div>
                        }
                    }
                  </div>
            
                  <!-- Plan Date -->
                  <div class="col-12 col-md-2">
                    <label class="form-label">Plan Date <span class="text-danger">*</span></label>
                    <div class="form-control-plaintext">{{ PlanDate?.split(' ')[0]}} </div>
                  </div>
            
                  <!-- Plan Time -->
                  <div class="col-12 col-md-2">
                    <label class="form-label">Plan Time <span class="text-danger">*</span> </label>
                    <div class="form-control-plaintext">{{ PlanTime }}</div>
                  </div>
            
                  <!-- Plan Action Type -->
                  <div class="col-12 col-md-4">
                    <label class="form-label">Plan Action Type <span class="text-danger">*</span></label>
                    <ng-select
                      [items]="planActionType"
                      bindLabel="MainDescr"
                      bindValue="hdID"
                      formControlName="DiaryPlanActionTypep"
                      placeholder="Select plan action type">
                    </ng-select>
                    @if (f.DiaryPlanActionTypep.touched && f.DiaryPlanActionTypep.invalid) {
                        @if (f.DiaryPlanActionTypep.errors?.['required']) {
                            <div class="text-danger">
                                <small>Plan Action Type is required.</small>
                            </div>
                        }
                    }
                  </div>
            
                  <!-- Plan Action For -->
                  <div class="col-12 col-md-4">
                    <label class="form-label">Plan of Action For <span class="text-danger">*</span></label>
                    <ng-select
                      [items]="Manager"
                      bindLabel="name"
                      bindValue="id1"
                      formControlName="DiaryPlanActionforp"
                      placeholder="Select Plan of Action For">
                    </ng-select>
                    @if (f.DiaryPlanActionforp.touched && f.DiaryPlanActionforp.invalid) {
                        @if (f.DiaryPlanActionforp.errors?.['required']) {
                            <div class="text-danger">
                                <small>Plan of Action For is required.</small>
                            </div>
                        }
                    }
                  </div>
            
                  <!-- Plan Description -->
                  <div class="col-12 col-md-4">
                    <label class="form-label">Plan Description</label>
                    <div class="form-control-plaintext">{{ PlanDescription }}</div>
                  </div>
            
                </div>
            </div>
         </div>
     }

    <!-- ===== Update Caption ===== -->
    <div class="page-sub-heading my-3">
    {{ UpdateCaption }}
    </div>

    <!-- ============================== -->
    <!--     SECTION: Update Diary      -->
    <!-- ============================== -->
     <div class="card">
        <div class="card-body">
            <div class="row mt-3">
        
              <!-- Date -->
              <div class="col-12 col-md-4">
                <label class="form-label">Date <span class="text-danger">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput [min]="minDate" [max]="maxDate" formControlName="FollowDate"
                         [matDatepicker]="pickerFollowupdate" placeholder="Choose date">
                  <mat-datepicker-toggle matSuffix [for]="pickerFollowupdate"></mat-datepicker-toggle>
                  <mat-datepicker #pickerFollowupdate></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="f.FollowDate.touched && f.FollowDate.invalid">
                  <small *ngIf="f.FollowDate.errors?.['required']">Date is required.</small>
                </mat-error>
              </div>
        
              <!-- In Time (Hour) -->
              <div class="col-6 col-md-2">
                <label class="form-label">In Time <span class="text-danger">*</span> </label>
                <input type="time" class="form-control" formControlName="InTime">
                          @if (f.InTime.touched && f.InTime.invalid) {
                           @if (f.InTime.errors?.['required']) {
                            <div class="text-danger">
                                <small>In Time is required.</small>
                            </div>
                           }
                          }
              </div>
        
              <!-- In Time (Min) -->
              <!-- <div class="col-6 col-md-2">
                <label class="form-label">In Min <span class="text-danger">*</span> </label>
                <ng-select [items]="minutes" bindLabel="label" bindValue="value"
                           formControlName="InMin" placeholder="Minute"></ng-select>
                          @if (f.InMin.touched && f.InMin.invalid) {
                           @if (f.InMin.errors?.['required']) {
                            <div class="text-danger">
                                <small>In Min is required.</small>
                            </div>
                           }
                          }
              </div> -->
        
              <!-- Out Time (Hour) -->
              <div class="col-6 col-md-2">
                <label class="form-label">Out Time <span class="text-danger">*</span> </label>
                <input type="time" class="form-control" formControlName="OutTime">
                @if (f.OutTime.touched && f.OutTime.invalid) {
                    @if (f.OutTime.errors?.['required']) {
                    <div class="text-danger">
                        <small>Out Time is required.</small>
                    </div>
                    }
                }
              </div>
        
              <!-- Out Time (Min) -->
              <!-- <div class="col-6 col-md-2">
                <label class="form-label">Out Min <sup class="text-danger">*</sup> </label>
                <ng-select [items]="minutes" bindLabel="label" bindValue="value"
                           formControlName="OutMin" placeholder="Minute"></ng-select>
                          @if (f.OutMin.touched && f.OutMin.invalid) {
                           @if (f.OutMin.errors?.['required']) {
                            <div class="text-danger">
                                <small>Out Min is required.</small>
                            </div>
                           }
                          }
              </div> -->
        
              <!-- Action Type -->
              <div class="col-12 col-md-4">
                <label class="form-label">
                  <a href="{{RouteGMActionType}}" target="_blank">Action Type</a>
                  <span class="text-danger">*</span>
                </label>
                <ng-select
                  [items]="FollowUpAction"
                  bindLabel="MainDescr"
                  bindValue="hdID"
                  formControlName="ActionType"
                  placeholder="Select action type">
                </ng-select>
                @if (f.ActionType.touched && f.ActionType.invalid) {
                    @if (f.ActionType.errors?.['required']) {
                        <div class="text-danger">
                            <small>Action Type is required.</small>
                        </div>
                    }
                }
              </div>
        
              <!-- Action Taken -->
              <div class="col-12 col-md-4">
                <label class="form-label">Action Taken <span class="text-danger">*</span></label>
                <textarea class="form-control" rows="2" formControlName="ActionTaken"
                          placeholder="Enter Action Description"></textarea>
                @if (f.ActionTaken.touched && f.ActionTaken.invalid) {
                    @if (f.ActionTaken.errors?.['required']) {
                        <div class="text-danger">
                            <small>Action Taken is required.</small>
                        </div>
                    }
                }
              </div>

             @if (CloseDiaryContextId == 'CloseDiaryNotice' || CloseDiaryContextId == 'CloseDiaryCase') {
                <div class="col-12 col-md-4">
                    <label class="form-label">Remarks</label>
                    <textarea class="form-control" rows="2" formControlName="Remarks"
                              placeholder="Enter remarks"></textarea>
                </div>
              }
        
              <!-- Attachments -->
              <div class="col-12 col-md-4">
                <label class="form-label">Attachments</label>
                <input type="file"  multiple (change)="onSelectFile($event)" formControlName="followupFiles">
              </div>

              @if (CloseDiaryContextId != 'CloseDiaryNotice' && CloseDiaryContextId != 'CloseDiaryCase') {
                  <div class="col-12 col-md-4 pt-4">
                    <input type="checkbox" (change)="onPlanToggle($event.target.checked)"> Set Next Plan
                  </div>
              }
        
            </div>
        </div>
     </div>

     @if (isPlanRequired) {
    <!-- ===== Next Plan Up ===== -->
     <div class="page-sub-heading my-3">
        Next Plan Up
     </div>
    <!-- <div class="col-12 fw-bold mt-4">Next Plan Up</div> -->
    <div class="card">
        <div class="card-body">
            <div class="row mt-3">
        
              <!-- Next Plan Date -->
              <div class="col-12 col-md-4">
                <label class="form-label">Plan Date <sup class="text-danger">*</sup> </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput [readonly]="!editable" [min]="minDate" [max]="maxDate"
                         formControlName="DiaryPlanDate" [matDatepicker]="picker1"
                         placeholder="Choose a date">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="f.DiaryPlanDate.touched && f.DiaryPlanDate.invalid">
                  <small *ngIf="f.DiaryPlanDate.errors?.['required']">Plan Date is required.</small>
                </mat-error>
              </div>
        
              <!-- Plan In Time Hour -->
              <div class="col-6 col-md-4">
                <label class="form-label">Plan In Time <sup class="text-danger">*</sup> </label>
                <input type="time" class="form-control" formControlName="planInTime">
                @if (f.planInTime.touched && f.planInTime.invalid) {
                    @if (f.planInTime.errors?.['required']) {
                        <div class="text-danger">
                            <small>Plan In Time is required.</small>
                        </div>
                    }
                }
              </div>
        
              <!-- Plan In Time Min -->
              <!-- <div class="col-6 col-md-2">
                <label class="form-label">Plan In Min <sup class="text-danger">*</sup> </label>
                <ng-select [items]="minutes" formControlName="PlanInMin" bindLabel="label" bindValue="value"
                           placeholder="Minute"></ng-select>
                @if (f.PlanInMin.touched && f.PlanInMin.invalid) {
                    @if (f.PlanInMin.errors?.['required']) {
                        <div class="text-danger">
                            <small>Plan In Min is required.</small>
                        </div>
                    }
                }
              </div> -->
        
              <!-- Plan Action Type -->
              <div class="col-12 col-md-4">
                <label class="form-label">
                  <a href="{{RouteGMPlanActionType}}" target="_blank">Plan Action Type</a> <span class="text-danger">*</span>
                </label>
                <ng-select
                  [items]="planActionType"
                  bindLabel="MainDescr"
                  bindValue="hdID"
                  formControlName="DiaryPlanActionType"
                  placeholder="Select plan action type">
                </ng-select>
                @if (f.DiaryPlanActionType.touched && f.DiaryPlanActionType.invalid) {
                    @if (f.DiaryPlanActionType.errors?.['required']) {
                        <div class="text-danger">
                            <small>Plan Action Type is required.</small>
                        </div>
                    }
                }
              </div>
        
              <!-- Plan Of Action For -->
              <div class="col-12 col-md-4">
                <label class="form-label">
                  <a href="{{RouteUserMaster}}" target="_blank">Plan of Action For</a> <span class="text-danger">*</span>
                </label>
                <ng-select
                  [items]="Manager"
                  bindLabel="name"
                  bindValue="id1"
                  formControlName="DiaryPlanActionfor"
                  placeholder="Select Plan of Action For">
                </ng-select>
                @if (f.DiaryPlanActionfor.touched && f.DiaryPlanActionfor.invalid) {
                    @if (f.DiaryPlanActionfor.errors?.['required']) {
                        <div class="text-danger">
                            <small>Plan of Action For is required.</small>
                        </div>
                    }
                }
              </div>
        
              <!-- Plan Description -->
              <div class="col-12 col-md-4">
                <label class="form-label">Plan Description <sup class="text-danger">*</sup> </label>
                <textarea class="form-control" rows="2"
                          formControlName="DiaryPlanDescription"
                          placeholder="Enter plan description"></textarea>
                @if (f.DiaryPlanDescription.touched && f.DiaryPlanDescription.invalid) {
                    @if (f.DiaryPlanDescription.errors?.['required']) {
                        <div class="text-danger">
                            <small>Plan Description is required.</small>
                        </div>
                    }
                }
              </div>
        
              <!-- Alert Days -->
              <div class="col-12 col-md-4">
                <label class="form-label">Send Alert Sms Before Days</label>
                <input type="number" class="form-control" min="0" 
                       formControlName="AlertTime" placeholder="Enter alert time" />
                @if (f.AlertTime.touched && f.AlertTime.invalid) {
                    @if (f.AlertTime.errors?.['required']) {
                        <div class="text-danger">
                            <small>Alert Time is required.</small>
                        </div>
                    }
                }
              </div>
        
            </div>
        </div>
    </div>
    }
    <!-- ===== SUBMIT BUTTON ===== -->

    <!-- @if (!HideButtonSubmit) { -->

        @if (RightsID.includes('202024001') || RightsID.includes('202024021')) {

        <div class="d-flex align-items-center justify-content-center mt-3" [hidden]="HideButtonSubmit" >
        <button class="btn btn-primary submit-btn"
                type="submit">
            Submit
        </button>
        </div>
        }

    <!-- } -->



  </form>
<!-- </div> -->
</div>


} @else {
    <!-- <my-content placeholder="navigation">
        <div class="col-sm-12 mt-3">
            <div class="titlebar d-flex align-items-center justify-content-between" *ngIf="this.PreFollowUPID == 0">
                <div></div>
                <div class="titlebar-text">
                    <i class="fa fa-briefcase text-primary"></i>
                    <span class="ml-2 page-title">Update Diary</span>
                </div>
    
                <button class="btn btn-primary back-btn " title="Go Back" (click)="goBack()">
                    <i class="fa fa-arrow-left"></i> Back
                </button>
            </div>
            <div class=" col-sm-12 lefticonD paddingless tableHeading" style="border-bottom: 1px solid #ccc;"
                *ngIf="this.PreFollowUPID != 0 && this.CloseDiaryHeader != 1"><span
                    style="color:red;">{{this.CaptionAlreadyDone}}</span></div>
             <div class="titlebar d-flex align-items-center justify-content-between" *ngIf="this.CloseDiaryHeader == 1">
                <div></div>
                <div class="titlebar-text">
                    <i class="fa fa-briefcase text-primary"></i>
                    <span class="ml-2 page-title">{{CloseCaption}}</span>
                </div>
    
                <button class="btn btn-primary back-btn " title="Go Back" (click)="goBack()">
                    <i class="fa fa-arrow-left"></i> Back
                </button>
            </div>
            <form #UpdateDiary="ngForm" [formGroup]="FormUpdateDiary" (ngSubmit)="onHeaderSubmit(UpdateDiary.value);">
                <div class="Col-sm-12" style="font-size: 14px; font-weight: bold;" *ngIf="this.CloseDiaryHeader != 1">
                    <br><br> My Diary</div>
                <table width="100%" class="LMtable_lite entry" *ngIf="this.CloseDiaryHeader != 1">
                    <tr>
                        <td width="10%">Diary Against</td>
                        <td width="23%">
                            <div class="col-sm-5">
                                <ng-select
                                  [items]="[{ value:2, label:'Case' }, { value:1, label:'Decision' }, { value:0, label:'Notice' }]"
                                  bindLabel="label"
                                  bindValue="value"
                                  formControlName="ContextType"
                                  (change)="onChangeContextType($event)"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                </ng-select>
                            </div>
                            <div class="col-sm-6">
                                <ng-select [items]="CaseNoticeList" [multiple]="false" formControlName="drpCaseNotice"
                                    bindLabel="refno" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID"
                                    [(ngModel)]="SelectedCaseNotice">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.refno}}&nbsp;&nbsp;&nbsp;({{item.type}})&nbsp;&nbsp;&nbsp;({{item.NoticeDt|date:'dd-MMM-yyyy'}})
                                    </ng-template>
                                </ng-select>
                            </div>
                        </td>
                        <td width="10%">Plan Date</td>
                        <td width="24%">
                            <div class="col-sm-11">
                                <label>{{PlanDate|date:'dd-MMM-yyyy'}}</label>
                            </div>
                        </td>
                        <td width="10%">Plan Time</td>
                        <td width="23%">
                            <div class="col-sm-11"> <label>{{PlanTime}}</label></div>
                        </td>
                    </tr>
                    <tr>
                        <td>Plan Action Type</td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select
                                  [items]="planActionType"
                                  bindLabel="MainDescr"
                                  bindValue="hdID"
                                  formControlName="DiaryPlanActionTypep"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                  <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td>Plan of Action For</td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select
                                  [items]="Manager"
                                  bindLabel="name"
                                  bindValue="id1"
                                  formControlName="DiaryPlanActionforp"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                </ng-select>
                            </div>
                        </td>
                        <td>Plan Description</td>
                        <td>
                            <div class="col-sm-11"><label>{{PlanDescription}}</label></div>
                        </td>
                    </tr>
                </table>
                <div class="Col-sm-12" style="font-size: 14px; font-weight: bold;"><br>{{this.UpdateCaption}}</div>
                <table width="100%" class="LMtable_lite entry">
                    <tr>
                        <td width="10%">Date<span style="color:red;">*</span></td>
                        <td width="23%">
                            <div class="col-sm-11">
                                <mat-form-field class="fullwidth">
                                    <input matInput [min]="minDate" formControlName="FollowDate" [max]="maxDate"
                                        [matDatepicker]="pickerFollowupdate" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="pickerFollowupdate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerFollowupdate></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </td>
                        <td width="10%">In Time</td>
                        <td width="24%">
                            <div class="col-sm-6">
                              <ng-select
                                [items]="hours"
                                bindLabel="label"
                                bindValue="value"
                                formControlName="InHour"
                                [clearable]="false"
                                placeholder="Hour">
                                <ng-option *ngFor="let h of hours" [value]="h.value">{{h.label}}</ng-option>
                              </ng-select>
                            </div>
                            <div class="col-sm-5">
                              <ng-select
                                [items]="minutes"
                                bindLabel="label"
                                bindValue="value"
                                formControlName="InMin"
                                [clearable]="false"
                                placeholder="Minute">
                                <ng-option *ngFor="let m of minutes" [value]="m.value">{{m.label}}</ng-option>
                              </ng-select>
                            </div>
                        </td>
    
                        <td width="10%">Out Time</td>
                        <td width="23%">
                            <div class="col-sm-6">
                              <ng-select
                                [items]="hours"
                                bindLabel="label"
                                bindValue="value"
                                formControlName="OutHour"
                                [clearable]="false"
                                placeholder="Hour">
                                <ng-option *ngFor="let h of hours" [value]="h.value">{{h.label}}</ng-option>
                              </ng-select>
                            </div>
                            <div class="col-sm-5">
                              <ng-select
                                [items]="minutes"
                                bindLabel="label"
                                bindValue="value"
                                formControlName="OutMin"
                                [clearable]="false"
                                placeholder="Minute">
                                <ng-option *ngFor="let m of minutes" [value]="m.value">{{m.label}}</ng-option>
                              </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteGMActionType}}" target="_blank">Action Type<span style="color:red;">*</span></a>
                        </td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select
                                  [items]="FollowUpAction"
                                  bindLabel="MainDescr"
                                  bindValue="hdID"
                                  formControlName="ActionType"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                  <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td>Action Taken<span style="color:red;">*</span></td>
                        <td>
                            <div class="col-sm-11"><textarea class="form-control" formControlName="ActionTaken" rows="2"
                                    placeholder="Enter Action Description"></textarea></div>
                        </td>
                        <td>Attachments</td>
                        <td>
                            <div class="col-sm-11"><input type='file' formControlName="followupFiles"
                                    (change)="onSelectFile($event)" multiple></div>
                        </td>
                    </tr>
                </table>
                <div class="Col-sm-12" style="font-size: 14px; font-weight: bold;"><br>Next Plan Up</div>
                <table width="100%" class="LMtable_lite entry">
                    <tr>
                        <td width="10%">Plan Date</td>
                        <td width="23%">
                            <div class="col-sm-11">
                                <mat-form-field class="fullwidth">
                                    <input matInput [readonly]="!editable" [min]="minDate" formControlName="DiaryPlanDate"
                                        [max]="maxDate" [matDatepicker]="picker1" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </td>
                        <td width="10%">Plan In Time</td>
                        <td width="24%">
                            <div class="col-sm-6">
                              <ng-select
                                [items]="hours"
                                bindLabel="label"
                                bindValue="value"
                                formControlName="PlanInHour"
                                [clearable]="false"
                                placeholder="Hour">
                                <ng-option *ngFor="let h of hours" [value]="h.value">{{h.label}}</ng-option>
                              </ng-select>
                            </div>
                            <div class="col-sm-5">
                              <ng-select
                                [items]="minutes"
                                bindLabel="label"
                                bindValue="value"
                                formControlName="PlanInMin"
                                [clearable]="false"
                                placeholder="Minute">
                                <ng-option *ngFor="let m of minutes" [value]="m.value">{{m.label}}</ng-option>
                              </ng-select>
                            </div>
                        </td>
                        <td width="10%"><a href="{{RouteGMPlanActionType}}" target="_blank">Plan Action Type</a></td>
                        <td width="23%">
                            <div class="col-sm-11">
                                <ng-select
                                  [items]="planActionType"
                                  bindLabel="MainDescr"
                                  bindValue="hdID"
                                  formControlName="DiaryPlanActionType"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                  <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteUserMaster}}" target="_blank">Plan of Action for</a></td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select
                                  [items]="Manager"
                                  bindLabel="name"
                                  bindValue="id1"
                                  formControlName="DiaryPlanActionfor"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                </ng-select>
                            </div>
                        </td>
                        <td>Plan Description</td>
                        <td>
                            <div class="col-sm-11"><textarea class="form-control" formControlName="DiaryPlanDescription"
                                    rows="2" placeholder="Enter Action Description"></textarea></div>
                        </td>
                        <td>Send Alert Sms Before Days</td>
                        <td>
                            <div class="col-sm-11"><input type="number" min="0" formControlName="AlertTime"
                                    class="form-control" placeholder="Enter Alert time Period" /></div>
                        </td>
                    </tr>
    
    
    
    
                </table>
    
                <div class="col-sm-12">&nbsp;</div>
                <div class="col-sm-12" [hidden]="HideButtonSubmit">
                    <div class="col-sm-5"></div>
                    <div class="form-group col-sm-4"
                        *ngIf="this.RightsID.includes('202024001') || this.RightsID.includes('202024021') ; then AddDiaryLink else AddDiaryNotLink">
                    </div>
                    <ng-template #AddDiaryLink>
                        <input class="btn btn-primary col-sm-2" type="submit" value="Submit">
                    </ng-template>
                    <ng-template #AddDiaryNotLink>
                        &nbsp;
                    </ng-template>
    
                    <div class="col-sm-5"></div>
                </div>
                <div class="col-sm-12">&nbsp;</div>
            </form>
            <div>&nbsp;</div>
        </div>
    </my-content> -->
}
